import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import { Route, Switch, useRouteMatch, Redirect } from 'react-router-dom';
import Header from '../../layout/Header';
import SideBar from '../../layout/SideBar';
import TeacherLesson from './TeacherLesson';
import TeacherHome from './TeacherHome';
import TeacherProfile from "./TeacherProfile";
import TeacherCreateCourse from "./TeacherCreateCourse";
import TeacherClasses from "./TeacherClasses";
import TeacherChangePassword from "./TeacherChangePassword";
import TeacherHomeWork from "./TeacherHomeWork";
import TeacherNote from "./TeacherNote";

export default function Teacher() {
    let { path } = useRouteMatch();
    //console.log(path);

    const [menuOpen, setMenuOpen] = useState<boolean>(true);
    const [menuClosed, setMenuClosed] = useState<boolean>(false);
    const [menuContent, setMenuContent] = useState<boolean>(true);

    // menu close
    function closeMenu(): void {
        setMenuOpen(false);
        setMenuClosed(true);
        setMenuContent(false);
    }

    // menu open
    function openMenu(): void {
        setMenuOpen(true);
        setMenuClosed(false);
        setMenuContent(true);
    }

    return (
        <Box>
            <SideBar menuOpen={menuOpen} menuClosed={menuClosed} menuContent={menuContent} openMenu={openMenu}
                closeMenu={closeMenu} />
            <Header menuOpen={menuOpen} menuClosed={menuClosed} menuContent={menuContent} openMenu={openMenu}
                closeMenu={closeMenu} />
            <Box ml={{ lg: "300px" }} onClick={() => closeMenu()}>
                <Switch>
                    <Route exact path={path} component={TeacherHome} />
                    <Route path={`${path}/classes`} component={TeacherClasses} />
                    <Route path={`${path}/assignments`} component={TeacherHomeWork} />
                    <Route path={`${path}/notes`} component={TeacherNote} />
                    <Route path={`${path}/lessons`} component={TeacherLesson} />
                    <Route path={`${path}/profile`} component={TeacherProfile} />
                    <Route path={`${path}/create-course`} component={TeacherCreateCourse} />
                    <Route path={`${path}/change-password`} component={TeacherChangePassword} />
                    <Route path="*">
                        <Redirect to={path} />
                    </Route>
                </Switch>
            </Box>
        </Box>
    )
}
